import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function BrandCard({ brand, logoOverride, premium = false }) {
  const isLight = brand.slug === "stories";
  const bg = isLight ? "#f4e9d4" : brand.slug === "gomill" ? "#1c6f3d" : "#125634";
  const logoSrc = logoOverride || brand.logo;

  return (
    <Link
      to={`/brands/${brand.slug}`}
      data-testid={`brand-card-${brand.slug}`}
      className="brand-card group block"
      style={{ backgroundColor: bg, color: isLight ? "var(--ink)" : "#fff" }}
    >
      <div className="aspect-[4/3] overflow-hidden bg-[#0d3a20]">
        <img
          src={brand.hero}
          alt={brand.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
      <div className="px-5 md:px-6 py-5 md:py-6 flex flex-col gap-3">
        {premium ? (
          <div className="h-16 md:h-20 flex items-center justify-start">
            <img
              src={logoSrc}
              alt={`${brand.name} logo`}
              className="h-full max-h-[68px] md:max-h-[80px] w-auto object-contain drop-shadow-[0_2px_8px_rgba(0,0,0,0.18)]"
            />
          </div>
        ) : (
          <div
            className="rounded-md inline-flex p-2 self-start h-14 items-center"
            style={isLight ? { background: "rgba(255,255,255,0.55)" } : { background: "rgba(255,255,255,0.12)", backdropFilter: "blur(6px)" }}
          >
            <img src={logoSrc} alt={`${brand.name} logo`} className="h-10 md:h-11 w-auto object-contain" />
          </div>
        )}
        <p className={`text-sm leading-snug line-clamp-2 ${isLight ? "text-[var(--ink-2)]" : "text-white/90"}`}>
          {brand.short}
        </p>
        <div className="mt-1 flex items-center justify-between">
          <span className={`kbd text-[0.62rem] ${isLight ? "text-[var(--green)]" : "text-[var(--gold-soft)]"}`}>
            {brand.category}
          </span>
          <span className="chip-circle" aria-hidden="true">
            <ArrowRight size={16} strokeWidth={1.6} className={isLight ? "text-[var(--green)]" : "text-white"} />
          </span>
        </div>
      </div>
    </Link>
  );
}
